import { render, staticRenderFns } from "./IntegrationFinished.vue?vue&type=template&id=2a964b19"
import script from "./IntegrationFinished.vue?vue&type=script&lang=js"
export * from "./IntegrationFinished.vue?vue&type=script&lang=js"
import style0 from "./IntegrationFinished.vue?vue&type=style&index=0&id=2a964b19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports